import { render, staticRenderFns } from "./ReportCardList.vue?vue&type=template&id=79b9d252&scoped=true&"
import script from "./ReportCardList.vue?vue&type=script&lang=js&"
export * from "./ReportCardList.vue?vue&type=script&lang=js&"
import style0 from "./ReportCardList.vue?vue&type=style&index=0&id=79b9d252&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79b9d252",
  null
  
)

export default component.exports